document.addEventListener("DOMContentLoaded", function () {
  const checkoutBtn = document.getElementById("checkout-button");

  if (!checkoutBtn) {
    console.warn("Checkout button not found in DOM.");
    return;
  }

  checkoutBtn.addEventListener("click", function (e) {
    const vatInputEl = document.querySelector(".bss-b2b-vat-input");
    const vatValue = vatInputEl ? vatInputEl.value.trim() : "";

    if (vatValue === "") {
      // Temporarily disable the VAT input so the BSS app doesn't validate it
      if (vatInputEl) {
        vatInputEl.disabled = true;
      }

      // Allow natural form behavior or redirect manually
      // If the button is a form submit, you don't need this redirect
      window.location.href = "/checkout";

      return;
    }

    // If VAT is entered, let the BSS app validate it
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // Find the target element after which you want to add the new tag
  const targetElement = document.querySelector('.bss-b2b-vat-input-wrapper');

  if (targetElement && targetElement.parentNode) {
    // Create the new div element
    const newDiv = document.createElement('div');
newDiv.classList.add('eu-input-custom-tag');
    // Set the text content of the new div
    newDiv.textContent = 'Click checkout to validate your VAT number.';

    // Insert the new div after the target element
    targetElement.parentNode.insertBefore(newDiv, targetElement.nextSibling);
  }
});
